export default "__VITE_ASSET__D7x1huyF__"